// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"141":"component---src-pages-markdown-remark-frontmatter-slug-tsx","218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"141":"ef18cd30791ba13a07ab","218":"7bec5804f2f456e04711","532":"4a9692eec8cc1ea773b8","691":"04faa0a9730c30c5e454"}[chunkId] + ".js";
};